"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
const tslib_1 = require("tslib");
const http_client_1 = require("@wix/http-client");
const retryUtils_1 = require("./retryUtils");
const parseResponse = (response) => response.data;
class HttpService {
    constructor(params) {
        this.revalidateAndRetry = (error) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const prevAppInstance = this.appInstance;
            this.appInstance = null;
            const retryConfig = error.config.retryConfig;
            if (retryConfig.revalidateAttempt >= retryConfig.maxRevalidate) {
                console.warn(`Max retries with revalidation reached`);
                return Promise.reject(error);
            }
            if (!this.revalidateAppInstance) {
                console.warn(`"revalidateAppInstance" wasn't provided`);
                return Promise.reject(error);
            }
            try {
                this.appInstance = yield this.revalidateAppInstance();
            }
            catch (e) {
                console.warn(`Error while revalidating session:`, e);
            }
            if (this.appInstance && this.appInstance !== prevAppInstance) {
                error.config.retryConfig.revalidateAttempt++;
                // HttpClient doesn't call "getAppToken" if "headers.authorization" is defined
                // thus need to eject previous (invalid) appInstance manually
                const _a = error.config.headers || {}, { authorization } = _a, headers = tslib_1.__rest(_a, ["authorization"]);
                return this.httpClient.request(Object.assign(Object.assign({}, error.config), { headers }));
            }
            return Promise.reject(error);
        });
        this.retry = (error) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { retryConfig } = error.config;
            if (retryConfig.retryAttempt >= retryConfig.maxRetry) {
                console.warn(`Max retries reached`);
                return Promise.reject(error);
            }
            const useExponentialBackoff = (0, retryUtils_1.isNetworkError)(error);
            yield (0, retryUtils_1.backoffDelay)(error.config, useExponentialBackoff);
            retryConfig.retryAttempt++;
            return this.httpClient.request(error.config);
        });
        this.onError = (error) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            // if request is cancelled
            if (http_client_1.HttpClient.isCancel(error)) {
                return Promise.reject(error);
            }
            if ((0, retryUtils_1.shouldRevalidateInstance)(error)) {
                return this.revalidateAndRetry(error);
            }
            const shouldRetryFn = error.config.retryConfig.shouldRetry || retryUtils_1.shouldRetryRequest;
            if (shouldRetryFn(error)) {
                return this.retry(error);
            }
            return Promise.reject(error);
        });
        const { baseURL = '', appInstance, revalidateAppInstance, additionalHeaders } = params || {};
        this.httpClient = new http_client_1.HttpClient({
            getAppToken: () => this.appInstance,
        });
        // @ts-expect-error
        this.httpClient.client.interceptors.response.use(null, this.onError);
        this.baseURL = baseURL;
        this.appInstance = appInstance;
        this.additionalHeaders = additionalHeaders;
        this.revalidateAppInstance = revalidateAppInstance;
    }
    setBaseURL(baseURL) {
        this.baseURL = baseURL;
    }
    setAppInstance(appInstance) {
        this.appInstance = appInstance;
    }
    setRevalidateAppInstance(revalidateAppInstance) {
        this.revalidateAppInstance = revalidateAppInstance;
    }
    request(requestConfig) {
        return this.httpClient
            .request(Object.assign(Object.assign({ baseURL: this.baseURL }, requestConfig), { headers: Object.assign(Object.assign({}, (this.additionalHeaders || {})), (requestConfig.headers || {})), withCredentials: this.baseURL !== '', retryConfig: Object.assign(Object.assign({}, retryUtils_1.RETRY_CONFIG_DEFAULT), (requestConfig.retryConfig || {})) }))
            .then(parseResponse);
    }
}
exports.HttpService = HttpService;
//# sourceMappingURL=index.js.map